import React from 'react'
import './icons.scss'

export const Menu = ({ isOpen = false }) => {

  return (
    <div className="menu">
      <div className="box">
        <div id="mobile-nav-icon" className={`btn ${isOpen ? 'open' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  )
}
